import { memo } from 'react';

import './Fallback.css';
import Spinner from '../Spinner/Spinner';

const Fallback = () => (
  <div className="dmf-fallback">
    <Spinner />
  </div>
);

// eslint-disable-next-line import/no-default-export
export default memo(Fallback);
